import React from "react";
import "./BasicBtn.css";


const BasicBtn = (props) => {
  const { text } = props;
  return (
    <div className="basic-btn-wrapper" onClick={props.onClick}>
      <div>{text}</div>
    </div>
  );
  
}
export default BasicBtn;